import { Flex, Text } from '@chakra-ui/react';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { ReactNode } from 'react';

export interface BreadcrumbItem {
  label: string;
  navobj?: Record<string, unknown>;
  route?: string;
  content?: ReactNode;
}

interface ClassicalBreadcrumbProps {
  items: BreadcrumbItem[];
}

export function ClassicalBreadcrumb({ items }: ClassicalBreadcrumbProps) {
  return (
    <Flex
      align="center"
      flexShrink={0}
      gap={1.5}
      minW={0}
      overflow="hidden"
      borderBottomWidth="1px"
      paddingBottom="2"
      flexWrap="wrap"
      borderColor="navigation.contextBorder"
      fontFamily="instrumentSans"
      fontSize="12px"
      lineHeight="15px"
    >
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;

        return (
          <Flex
            key={`${item.label}-${index}`}
            align="center"
            flex="0 0 auto"
            maxW="100%"
            minW={0}
            gap={1.5}
          >
            {index > 0 && (
              <Text color="navigation.breadcrumbSeparator" flexShrink={0}>
                ›
              </Text>
            )}
            {item.content ? (
              item.content
            ) : item.route && item.navobj ? (
              <AngularNavLink
                to={item.route}
                navobj={item.navobj}
                variant="navigationBreadcrumb"
              >
                <Text noOfLines={1}>{item.label}</Text>
              </AngularNavLink>
            ) : (
              <Text
                color={
                  isCurrent
                    ? 'navigation.breadcrumbCurrent'
                    : 'navigation.contextMuted'
                }
                flex={isCurrent ? 1 : undefined}
                minW={0}
                fontWeight={isCurrent ? 'semibold' : 'normal'}
                noOfLines={1}
              >
                {item.label}
              </Text>
            )}
          </Flex>
        );
      })}
    </Flex>
  );
}
